/* THE ILLUMINATEE - product-row white fade-in scroll reveal.
   Cards start under a white veil and rise into place in a left-to-right
   cascade per row. Tweakables at the top: STAGGER, DURATION, SHIFT, MARGIN, COLOR. */
(function () {
  'use strict';
  if (window.__illRowReveal) return;
  window.__illRowReveal = true;

  var SELECTOR = '.product-grid__item, .resource-list__item';
  var STAGGER = 90;
  var DURATION = 600;
  var ROW_TOL = 24;
  var MARGIN = '0px 0px -10% 0px';
  var COLOR = '#ffffff';
  var SHIFT = 14;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsHas = false;
  try { supportsHas = window.CSS && CSS.supports && CSS.supports('selector(:has(*))'); } catch (error) {}
  if (reduce || !supportsHas) return;

  var de = document.documentElement;
  de.style.setProperty('--ill-reveal-color', COLOR);
  de.style.setProperty('--ill-reveal-dur', DURATION + 'ms');
  de.style.setProperty('--ill-shift', SHIFT + 'px');
  de.classList.add('ill-reveal-on');

  function buildRows(items) {
    var measured = items.map(function (el) {
      var rect = el.getBoundingClientRect();
      return { el: el, top: rect.top + window.pageYOffset, left: rect.left + window.pageXOffset };
    }).sort(function (a, b) { return (a.top - b.top) || (a.left - b.left); });

    var rows = [];
    var current = null;
    var lastTop = null;
    measured.forEach(function (measurement) {
      if (lastTop === null || Math.abs(measurement.top - lastTop) > ROW_TOL) {
        current = [];
        rows.push(current);
        lastTop = measurement.top;
      }
      current.push(measurement.el);
    });
    return rows;
  }

  var observer = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target._illRow) revealRow(entry.target._illRow);
        });
      }, { root: null, rootMargin: MARGIN, threshold: 0.01 })
    : null;

  function revealRow(group) {
    group.forEach(function (el) {
      if (el.classList.contains('ill-shown')) return;
      el.classList.add('ill-shown');
      if (observer) observer.unobserve(el);
    });
  }

  function track(scope) {
    var items = Array.prototype.slice
      .call((scope || document).querySelectorAll(SELECTOR))
      .filter(function (el) { return !el._illTracked && el.querySelector('product-card, .product-card'); });
    if (!items.length) return;

    buildRows(items).forEach(function (group) {
      group.forEach(function (el, column) {
        el._illTracked = true;
        el._illRow = group;
        el.style.setProperty('--ill-delay', (column * STAGGER) + 'ms');
        if (observer) observer.observe(el);
        else el.classList.add('ill-shown');
      });
    });
  }

  function revealInView() {
    void de.offsetHeight;
    var viewportHeight = window.innerHeight || de.clientHeight;
    Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).forEach(function (el) {
      if (!el._illRow || el.classList.contains('ill-shown')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < viewportHeight && rect.bottom > 0) revealRow(el._illRow);
    });
  }

  function regroup() {
    var pending = Array.prototype.slice
      .call(document.querySelectorAll(SELECTOR))
      .filter(function (el) { return el._illTracked && !el.classList.contains('ill-shown'); });
    if (!pending.length) return;

    buildRows(pending).forEach(function (group) {
      group.forEach(function (el, column) {
        el._illRow = group;
        el.style.setProperty('--ill-delay', (column * STAGGER) + 'ms');
      });
    });
  }

  function reobservePending() {
    if (!observer) return;
    Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).forEach(function (el) {
      if (el._illTracked && !el.classList.contains('ill-shown')) observer.observe(el);
    });
  }

  function refresh() {
    track(document);
    regroup();
    reobservePending();
    revealInView();
  }

  function start() {
    try {
      refresh();

      if ('MutationObserver' in window) {
        var queued = false;
        var queueRefresh = function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            refresh();
          });
        };

        new MutationObserver(function (mutations) {
          for (var index = 0; index < mutations.length; index++) {
            var mutation = mutations[index];
            var target = mutation.target;
            var targetIsRelevant = target.nodeType === 1 && (
              (target.matches && target.matches(SELECTOR)) ||
              (target.closest && target.closest(SELECTOR)) ||
              (target.querySelector && target.querySelector(SELECTOR))
            );

            if (targetIsRelevant) {
              queueRefresh();
              return;
            }

            if (mutation.type !== 'childList') continue;
            var changedNodes = Array.prototype.slice.call(mutation.addedNodes)
              .concat(Array.prototype.slice.call(mutation.removedNodes));
            for (var nodeIndex = 0; nodeIndex < changedNodes.length; nodeIndex++) {
              var node = changedNodes[nodeIndex];
              if (node.nodeType === 1 && (
                (node.matches && node.matches(SELECTOR)) ||
                (node.querySelector && node.querySelector(SELECTOR))
              )) {
                queueRefresh();
                return;
              }
            }
          }
        }).observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });

        window.addEventListener('pageshow', queueRefresh);
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          regroup();
          reobservePending();
          revealInView();
        }, 150);
      }, { passive: true });
    } catch (error) {
      de.classList.remove('ill-reveal-on');
      if (window.console) console.warn('[ill-row-reveal] disabled:', error);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
